<template>
    <add-edit-escalationfactor></add-edit-escalationfactor>
</template>

<script>
import AddEditEscalationfactor from "@/layouts/components/risk-management/escalation-factors/addedit-escalationfactor.vue";

export default {
 components : {
   AddEditEscalationfactor
 },
};
</script>